import RateCardComponent from "../Components/RateCard/RateCardComponent"

function RateCardPage() {
    return (

        <RateCardComponent/>
    )
}

export default RateCardPage